import { frontendURL } from '../../../helper/URLHelper';

const AcademyIndexPage = () => import('./pages/AcademyIndexPage.vue');
const AcademyLessonPage = () => import('./pages/AcademyLessonPage.vue');

// Academia ChatSuite: catálogo de treinamentos da plataforma, somente
// leitura — visível para qualquer papel em qualquer conta.
const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  // Treinamentos NÃO mostra a wiki (acervos 100% separados no menu).
  {
    path: frontendURL('accounts/:accountId/academia'),
    name: 'academy_index',
    component: AcademyIndexPage,
    props: { excludeSlug: 'wiki' },
    meta,
  },
  // Wiki da plataforma: mesma página dos Treinamentos, filtrada no acervo
  // de slug "wiki" — item próprio no menu (pedido Ivan 28/08).
  {
    path: frontendURL('accounts/:accountId/wiki'),
    name: 'academy_wiki',
    component: AcademyIndexPage,
    props: { portalSlug: 'wiki' },
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/academia/:articleSlug'),
    name: 'academy_lesson',
    component: AcademyLessonPage,
    meta,
  },
];
